export default __webpack_public_path__ + "static/media/status-ok-icon.84b2a851.svg";